"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionActionEnum = void 0;
var CollectionActionEnum;
(function (CollectionActionEnum) {
  /** Могу изменить общие сведения */
  CollectionActionEnum["edit"] = "edit";
  /** Могу купить лицензию на коллекцию */
  CollectionActionEnum["buy"] = "buy";
  /** Могу улучшить лицензию на коллекцию */
  CollectionActionEnum["upgrade"] = "upgrade";
  /** Могу оставить отзыв на коллекцию */
  CollectionActionEnum["review"] = "review";
  /** Могу опубликовать */
  CollectionActionEnum["publish"] = "publish";
  /** Могу снять с публикации */
  CollectionActionEnum["unpublish"] = "unpublish";
  /** Могу архивировать */
  CollectionActionEnum["archive"] = "archive";
  /** Могу восстановить из архива */
  CollectionActionEnum["restore"] = "restore";
})(CollectionActionEnum = exports.CollectionActionEnum || (exports.CollectionActionEnum = {}));
